export default __webpack_public_path__ + "static/media/twitter.709a5490.svg";